module.exports = __webpack_public_path__ + "img/chevron-solid-white.d429a230.svg";